import { RequestCookie } from 'next/dist/compiled/@edge-runtime/cookies';

import isNil from 'lodash/isNil';

import { FeatureToggleEnum } from '@nocowanie/core/enums';
import { featureToggleHelpers } from '@nocowanie/core/helpers';

import type { AppDispatch } from '@app/app-state';

import { getFeatureToggleEnvValue } from './feature-toggle-env.helpers';

import { setFeatureToggle, setIsSession } from '../slices/common-ui-state.slice';

export const handleCookiesAppRouter = (
    { isSession, cookies }: { isSession: boolean; cookies: RequestCookie[] },
    dispatch: AppDispatch,
) => {
    const ftCookies = Object.values(FeatureToggleEnum);

    for (const key of ftCookies) {
        const cookieValue =
            cookies.find(({ name }) => name === key)?.value ?? getFeatureToggleEnvValue(key);
        if (isNil(cookieValue)) {
            continue;
        }

        dispatch(
            setFeatureToggle({
                [key]: featureToggleHelpers.FeatureToggleValueParserMap?.[key]?.(`${cookieValue}`),
            }),
        );
    }

    dispatch(setIsSession(isSession));
};
